module.exports = __webpack_public_path__ + "static/media/flag01.ff9e2c96.svg";